import Markdown, { type MarkdownToJSX } from 'markdown-to-jsx';
import { useMemo } from 'react';

import { type AnalyticsId } from './AnalyticsProvider/AnalyticsProvider';

import { Link } from '../server/Link/Link';

type Props = {
	analyticsId: AnalyticsId;
	children: string;
	components?: MarkdownToJSX.Overrides;
};

export const MarkdownContent = ({ children, analyticsId, components }: Props) => {
	const baseComponents = useMemo<MarkdownToJSX.Overrides>(
		() => ({
			a: {
				component: ({ children, href }) => {
					if (!href) return <span>{children}</span>;
					return (
						<Link analyticsId={`${analyticsId}-${href}`} className="w-fit inline" href={href} target="_blank">
							{children}
						</Link>
					);
				},
			},
		}),
		[analyticsId],
	);
	return <Markdown options={{ overrides: { ...baseComponents, ...components } }}>{children}</Markdown>;
};
